export default __webpack_public_path__ + "static/vikrant3-7d37a446b7a3dfc6ea20e73dbd68f8af.jpg";